// AUTO-GENERATED by scripts/inject-version.cjs — DO NOT EDIT.
// Regenerated on every `npm start` / `npm run build`.
// APP_VERSION is the semver from package.json (the user-facing display).
// APP_SHA / APP_FULL_SHA / APP_BRANCH / APP_BUILT_AT are recorded for
// the footer tooltip and debugging.
export const APP_VERSION   = "0.9.1";
export const APP_SHA       = "305f48d";
export const APP_FULL_SHA  = "305f48dbe43d0bdf85dde59f7440889e5f226929";
export const APP_BRANCH    = "master";
export const APP_BUILT_AT  = "2026-10-20T17:16:19.322Z";
